export default [
    {
        path: 'avaliacao',
        component: () => import(
            '@/views/atencao-basica/avaliacao/Index'
        ),
        redirect: 'avaliacao/index',
        children: [
            {
                name: 'atencao-basica-avaliacao',
                path: 'index',
                props: true,
                component: () => import(
                    '@/views/atencao-basica/avaliacao/List'
                ),
            },
            {
                name: 'atencao-basica-avaliacao-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/atencao-basica/avaliacao/Form'
                )
            },
            {
                name: 'atencao-basica-avaliacao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id), edit: true }),
                component: () => import(
                    '@/views/atencao-basica/avaliacao/Form'
                )
            },
        ],
    },
]